export default __webpack_public_path__ + "static/media/IMG_8592.e85d5b29.JPG";